import basePickBy from './_basePickBy.js';
import hasIn from './hasIn.js';

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

export default basePick;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_basePick.js
// module id = 1191
// module chunks = 0